import { Classes } from "@blueprintjs/core";
import { rgba } from "polished";
import React, { ComponentPropsWithoutRef } from "react";
import styled from "styled-components";

const IconWrapper = styled.span<{
  $color?: string;
  $small?: boolean;
}>`
  background-color: ${({ $color, theme }) =>
    rgba($color ?? theme.iconColor, 0.1)};
  width: ${({ $small }) => ($small ? 26 : 32)}px;
  height: ${({ $small }) => ($small ? 26 : 32)}px;
  padding: ${({ $small }) => ($small ? "3px 5px" : "6px")};
  border-radius: 50%;
  .${Classes.ICON} {
    svg {
      width: ${({ $small }) => ($small ? 16 : 20)}px;
      height: ${({ $small }) => ($small ? 16 : 20)}px;
      color: ${({ $color }) => $color};
    }
  }
`;

export interface HexTitleIconProps extends ComponentPropsWithoutRef<"span"> {
  children: React.ReactNode;
  color?: string;
  small?: boolean;
}

export const HexTitleIcon: React.ComponentType<HexTitleIconProps> = ({
  color,
  small = false,
  ...props
}) => <IconWrapper $color={color} $small={small} {...props} />;
